export default "__VITE_ASSET__nYGEQ6HM__"